
export default {
    accessToken: "",
}